import React, { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { ErrorCurtain } from '../components/ErrorCurtain';
import { useAccountContext } from '../hooks/useCurrentAccount';
import { FullScreenLayout } from '../layouts/FullScreenLayout';

export const RequireAccountRoute: React.FC<PropsWithChildren> = ({
  children
}) => {
  const { isUnauthorized, account, error } = useAccountContext();
  if (isUnauthorized) {
    return <Navigate to="/login" />;
  }

  if (error) {
    return (
      <FullScreenLayout>
        <ErrorCurtain error={error} />
      </FullScreenLayout>
    );
  }

  if (!account) {
    return <Navigate to="/login" />;
  }
  return children;
};

/**
 * @deprecated
 */
export const RequireUserRoute = RequireAccountRoute;
